/* global woocommerce_params, script_l10n */
import Cart from './cart';
import autosizeInput from '../plugins/autosize-input';
import { validatePostalCode, validateEmail } from '../../../includes/mlmi-elements/utils';

export default {
  init() {
    if ($('.form-plan').length > 0) {
      $('.form-plan__input:not(#field-password)').each(function () {
        autosizeInput($(this).get(0), {
          minWidth: true
        });

        if ($(this).val() && $(this).hasClass('form-plan__input--autoselect')) {
          $(this).on('focus click mousedown mouseup', function (e) {
            e.preventDefault();
            $(this).select();
          });
        }
      });

      $('.form-plan__group').on('mouseup', function (e) {
        window.requestAnimationFrame(function () {
          $(e.currentTarget).find('input[type="radio"]').blur();
        });
      });

      $('select[name="field-allergies"]')
        .on('change', function () {
          if ($(this).val() == 'none') {
            $('.is-allergic').hide();
          } else {
            $('.is-allergic').show();
          }
        })
        .trigger('change');

      $('select[name="field-gender"]').on('change', function () {
        let genderValue = $(this).val();
        $('span[data-toggled="gender"]').each(function () {
          let choices = JSON.parse(atob($(this).data('toggle')));
          $(this).text(choices[genderValue == 'Elle' ? 0 : 1]);
        });
      });

      $('[data-value-from]').each(function () {
        let holder = $(this);
        let language = holder.data('language');
        let initialValue = holder.text();
        let field = $('input[name="' + $(this).data('value-from') + '"]');
        field
          .on('change', function () {
            if (field.val()) {
              let nameValue = field.val();
              if (language == 'fr') {
                if (
                  ['a', 'e', 'i', 'o', 'u', 'h'].indexOf(
                    nameValue
                      .charAt(0)
                      .toLowerCase()
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                  ) !== -1
                ) {
                  nameValue = "d'" + nameValue;
                } else {
                  nameValue = 'de ' + nameValue;
                }
              }
              holder.text(nameValue);
            } else {
              holder.text(initialValue);
            }
          })
          .trigger('change');
      });

      $('.form-plan').each(function () {
        let self = $(this);

        self.action = self.find('input[name="action"]').val();
        self.fields = self.find(':input:not(button)');
        self.el = {
          submit: self.find('.form-plan__submit')
        };

        self.get_form_data = function () {
          let data = {
            action: self.action
          };
          self.fields.each(function () {
            let field = $(this),
              fieldName = field.attr('name'),
              fieldType = field.prop('tagName').toLowerCase() == 'input' ? field.attr('type') : field.prop('tagName').toLowerCase();
            if (fieldType == 'radio' || fieldType == 'checkbox') {
              if (field.prop('checked') == true) {
                data[fieldName] = field.val();
              }
            } else {
              data[fieldName] = field.val();
            }
          });
          return data;
        };

        self.handle_submit = function (e) {
          e.preventDefault();
          self.el.submit.prop('disabled', true);
          $('.form-plan__error').slideUp();
          $('.form-plan__field--error').removeClass('form-plan__field--error');
          setTimeout(function () {
            $('.form-greeting').addClass('form-greeting--visible');
          }, 100);
          setTimeout(function () {
            let data = self.get_form_data();
            $.post(woocommerce_params.ajax_url, data, self.handle_response, 'json');
          }, 350);
        };

        self.handle_response = function (response) {
          if (response.success) {
            self.handle_success(response);
          } else {
            self.handle_error(response);
          }
        };

        self.handle_success = function (response) {
          Cart.refresh(response);
        };

        self.handle_error = function (response) {
          self.el.submit.prop('disabled', false);
          $('.form-plan__error').remove();
          $('.form-plan__wrapper').prepend($('<div class="form-plan__error"></div>').html(response.error));
          $('.form-greeting').removeClass('form-greeting--visible');
          for (let field in response.errors) {
            let element = self.find('[name="' + field + '"]');
            if (element.closest('.form-plan__field').hasClass('form-plan__field--visible')) {
              element.closest('.form-plan__field').addClass('form-plan__field--error');
            }
          }
          self.update_height();
          let windowTarget = 0;
          if ($(window).scrollTop() > windowTarget) {
            $('html, body').animate(
              {
                scrollTop: windowTarget + 'px'
              },
              450
            );
          }
        };

        self.check_ready = function () {
          let group = $(this).closest('.form-plan__field'),
            nextGroup = group.next('.form-plan__field'),
            fields = $(group).find('input:not([type="radio"]), input[type="radio"]:checked, select'),
            allValid = true;

          if (nextGroup.hasClass('form-plan__field--visible') && !group.hasClass('form-plan__field--retry')) {
            return;
          }

          if (fields.length === 0) {
            allValid = false;
          }

          fields.each(function () {
            let field = $(this);
            if (!field.val() || field.val() == '0') {
              allValid = false;
            } else if (field.attr('name') == 'field-postcode' && !validatePostalCode(field.val())) {
              allValid = false;
            } else if (field.attr('name') == 'field-postcode') {
              // valid -> server validation
              self.validate_postal_code(field.val());
              $('input[name="field-postcode"] + .form-plan__notification').remove();
              group.removeClass('form-plan__field--retry');
            } else if (field.attr('name') == 'field-email' && !validateEmail(field.val())) {
              allValid = false;
            } else if (field.attr('name') == 'field-email') {
              // valid -> server validation
              self.validate_email_account(field.val());
              $('input[name="field-email"] + .form-plan__notification').remove();
              group.removeClass('form-plan__field--retry');
            } else if (
              (field.attr('name') == 'field-age' || field.attr('name') == 'field-weight' || field.attr('name') == 'field-birthday') &&
              !parseInt(field.val(), 10)
            ) {
              allValid = false;
            } else if (field.attr('name') == 'field-password' && field.val().length < 8) {
              allValid = false;
            }
          });

          if (allValid) {
            nextGroup.addClass('form-plan__field--visible');
            self.update_height();
          }
        };

        self.update_height = function () {
          let targetHeight = 0;
          $('.form-plan__field--visible, .form-plan__error').each(function () {
            targetHeight += $(this).outerHeight(true);
          });
          self.css({
            height: targetHeight + 'px'
          });
        };

        self.validate_postal_code = function (postal_code) {
          $.post(
            woocommerce_params.ajax_url,
            {
              action: 'validate_postal_code_for_shipping',
              postal_code: postal_code
            },
            function (isValid) {
              $('input[name="field-postcode"] + .form-plan__notification').remove();
              if (isValid === 'no') {
                let notification = $('<div class="form-plan__notification">').html(script_l10n.NO_SHIPPING_ZONE);
                $('input[name="field-postcode"]').after(notification).closest('.form-plan__field').addClass('form-plan__field--retry');
                self.update_height();
              }
            },
            'text'
          );
        };

        self.validate_email_account = function (email_address) {
          $.post(
            woocommerce_params.ajax_url,
            {
              action: 'validate_email_without_account',
              email_address: email_address
            },
            function (isValid) {
              $('input[name="field-email"] + .form-plan__notification').remove();
              if (isValid === 'no') {
                let notification = $('<div class="form-plan__notification">').html(script_l10n.EMAIL_HAS_ACCOUNT);
                $('input[name="field-email"]').after(notification).closest('.form-plan__field').addClass('form-plan__field--retry');
                self.update_height();
              }
            },
            'text'
          );
        };

        return (function () {
          self.on('submit', self.handle_submit);
          $('.form-plan__field')
            .slice(0, $('.form-plan__field--filled:not(.form-plan__field--empty):last').index() + 2)
            .addClass('form-plan__field--visible');
          $('.form-plan__field--error').not('.form-plan__field--visible').removeClass('form-plan__field--error');
          self.fields.on('change keyup', self.check_ready);
          self.update_height();
          $('.app').after($('.form-greeting'));
          setTimeout(function () {
            self.fields.first().focus();
          }, 250);
          self.on('click', '.showlogin', function () {
            $.fancybox.open({
              src: $('form.woocommerce-form-login'),
              type: 'inline'
            });
            return false;
          });
          return self;
        })();
      });
    }
  }
};
